import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import { isClientErrorCode } from "Shared/utils/errorHandler.utils"
import * as Sentry from "@sentry/react"
import { invalidateDeliveryNoteCache, invalidateDeliveryNoteDetail } from "Features/pages/deliveryNotes/queries/deliveryNote.queries"

export const subscribeToDeliveryNotes = async (_: any, data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    try {
        switch (operationType) {
            case OperationTypeEnum.INSERT:
            case OperationTypeEnum.UPDATE:
                await invalidateDeliveryNoteCache()
                break
            case OperationTypeEnum.DELETE:
                await invalidateDeliveryNoteCache()
                break
            case OperationTypeEnum.UPDATE_COMMENT:
            case OperationTypeEnum.INSERT_COMMENT:
            case OperationTypeEnum.DELETE_COMMENT:
                await invalidateDeliveryNoteDetail(documentId?.toString())
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Delivery Note Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
